import { FluidGridProps } from '@design-system/fluid-grid';
import { ImageBlockProps } from '@design-system/image-block';
import { SearchResultsHeaderProps } from '@design-system/search-results-header';

import { ArticleSearchResult } from '../../services/search/config/articles/types';
import { ProductSearchResult } from '../../services/search/config/products/types';

export enum SearchingState {
  pending = 'pending',
  results = 'results',
  noResults = 'noResults',
  emptyPhrase = 'emptyPhrase',
}

export enum TabsVariant {
  allResults = 0,
  productsTab = 1,
  articlesTab = 2,
}

export interface SearchResultsProps {
  resultsTab: string;
  productTab: string;
  articleTab: string;
  moreResultsButtonLabel: string;
  moreProductsButtonLabel: string;
  moreArticlesButtonLabel: string;
  initialVisibleItems: number;
  header: SearchResultsHeaderProps;
  imageSettings: ImageBlockProps;
  fluidGrid: FluidGridProps;
  locale: string;
  uid: string;
  componentId?: string;
}

export interface ArticleListingProps {
  items: Array<ArticleSearchResult>;
  maxVisibleItems?: number;
  tabNumber: number;
  setTabValue: (value: number) => void;
  moreButtonText: string;
}

export interface ProductListingProps {
  items: Array<ProductSearchResult>;
  imageSettings: ImageBlockProps;
  maxVisibleItems?: number;
  tabNumber: number;
  setTabValue: (value: number) => void;
  moreButtonText: string;
  fluidGrid: FluidGridProps;
}

export interface SearchResultSkeletonProps {
  initialVisibleItems: number;
}
